var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-container"},[_c('img',{staticClass:"item-top-icon",attrs:{"src":_vm.active ? _vm.activeIcon : _vm.inactiveIcon}}),_vm._v(" "),_c('div',{class:_vm.active ? 'item-bottom-active' : 'item-bottom-inactive'},[_vm._v("\n    "+_vm._s(this.text)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0c33062","hasScoped":true,"transformToRequire":{"video":["app","poster"],"source":"app","img":"app","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/components/footer/FooterItem.vue
// module id = null
// module chunks = 